import { Typography, Stack } from "@mui/material"
import { useLocales } from '@locales';

const getLowestPrice = (ticketTypes) => {
    return ticketTypes.reduce((acc, curr) => {
        if (acc.price < curr.price) {
            return acc
        }
        return curr
    })
}

const getHighestPrice = (ticketTypes) => {
    return ticketTypes.reduce((acc, curr) => {
        if (acc.price > curr.price) {
            return acc
        }
        return curr
    })
}
/**
 * 
 * get the pricing configuration for the event same in the same format as the pricing passed to seats.io
 * display the ticket pricing for the event
 */
const SeatsTicketPricing = ({ pricing }) => {
    const seatingCategories = (pricing || []).filter((sc) => sc.quantity > 0)
    const {translate} = useLocales()
    return (
        <Stack >
            {seatingCategories.map((sc) => (
                <Stack direction={"row"} key={sc.category} gap={1}>
                    <Category name={sc.category} color={sc.color} />
                    {sc.ticketTypes && <>
                        <Typography>{translate('currency.format', { value: getLowestPrice(sc.ticketTypes).price })}</Typography>
                        -
                        <Typography>{translate('currency.format', { value: getHighestPrice(sc.ticketTypes).price })}</Typography>
                    </>}
                    {!sc.ticketTypes && <Typography>{sc.price}</Typography>}
                </Stack>
            ))}
        </Stack>
    )
}

const Category = ({ name, color }) => {
    return (
        <Stack direction={"row"} alignItems={"center"} gap={1}>
            <span style={{
                display: 'inline-block',
                width: "10px",
                height: "10px",
                backgroundColor: color,
                borderRadius: "50%",
            }}></span>
            <Typography>{name}</Typography>
        </Stack>
    )
}

export default SeatsTicketPricing;